// The shortcut: Alt+Shift+S (⌥⇧S on a Mac). Matched by the key's position (KeyS) as well as its letter: on a Mac,
// Option turns the letter into "Í", and other layouts move it. Free in Chrome, Edge, Firefox and Safari on Windows and
// Mac (Ctrl+Shift+S is Edge's web capture), and AltGr (Ctrl+Alt on Windows) can't set it off. It works in text fields
// too: the key is taken, so nothing is typed. (`~` was a dead key or an AltGr combination on many layouts.)

export const isSnagKey = (e: KeyboardEvent) =>
  e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey && (e.code === "KeyS" || e.key.toLowerCase() === "s");

/** How to write the shortcut for this person's keyboard. */
export const snagKeyLabel = () => (/Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? "⌥⇧S" : "Alt+Shift+S");
